import React from "react";
import { sendRelatedQuestionClick } from "../../utils/analyticsEvents";

interface RelatedQuestionsProps {
  relatedQuestions: string[];
  onQuestionClick: (question: string) => void;
}

const RelatedQuestions: React.FC<RelatedQuestionsProps> = ({
  relatedQuestions,
  onQuestionClick,
}) => {
  if (!relatedQuestions) {
    return null;
  }

  const handleQuestionClick = (question: string) => {
    sendRelatedQuestionClick(question);

    onQuestionClick(question);
  };

  return (
    <div>
      {relatedQuestions && relatedQuestions.length > 0 && (
        <h2 className="text-xl mb-3 font-flexo-demi py-2">
          Preguntas relacionadas
        </h2>
      )}
      <ul className="space-y-4 text-sm font-flexo-demi text-BCP-normal-text">
        {relatedQuestions.map((question, index) => (
          <li
            key={index}
            className="flex items-center justify-between border-b border-BCP-gray-border pb-3 hover:underline cursor-pointer"
          >
            <button
              onClick={() => handleQuestionClick(question)}
              className="flex-grow text-left"
            >
              {question}
            </button>
            <i className="pi pi-angle-right text-sm" />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RelatedQuestions;
